import React from "react";

import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import Card from "../../../../layout/Onboarding/Card";
import Lable from "../../../../components/formElements/label/Label";
import CardLable from "../../../../components/formElements/label/CardLabel";

export const FamilyaMedicalConditionCard = ({
  addFamilyMedicalHistory,
  personalPatientInfo,
  setPatientPersonalInfo,
  removeFamilyMedicalHistory,
  form,
}) => {
  return (
    <Card>
      <Row className="mt-4 mb-4">
        <Col>
          <CardLable
            name="Family Medical History"
            condition={personalPatientInfo.current_family_medical_history}
            onclick={() => addFamilyMedicalHistory()}
            labelName={
              personalPatientInfo.current_family_medical_history ? "Add" : ""
            }
          />
        </Col>
        <Col className="mt-3 mb-n4">
          <TextInput
            id="current_family_medical_history"
            // error={form.family_medical_history}
            type="text"
            label="Family Medical History"
            value={personalPatientInfo.current_family_medical_history}
            onChange={val =>
              setPatientPersonalInfo({
                current_family_medical_history: val,
              })
            }
          />
        </Col>
        {personalPatientInfo.family_medical_history
          ? personalPatientInfo.family_medical_history.map((value, index) => (
              <Col className="mt-n1 mb-4">
                <Lable
                  name="family-medical-condition"
                  onclick={() => removeFamilyMedicalHistory(index)}
                  value={value}
                />
              </Col>
            ))
          : ""}
      </Row>
    </Card>
  );
};
